<template>
    <section>
        <div class="bg-gradient-to-l from-theme1 to-theme2">
            <div class="container py-3 justify-between items-center flex flex-row">
                <LoadItemText class="text-white text-xl font-medium leading-7">
                    Loading Step..
                </LoadItemText>
                <div class="flex items-center justify-center flex-row gap-3">
                    <LoadItem v-for="(item, index) in 4"
                        :class="`w-[100px] rounded h-6 animation-delay-${index}00 max-sm:hidden ${index === 0 ? '!block' : ''}`" />
                </div>
            </div>
        </div>
        <div class="container py-6 pb-12">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
                <div class="lg:col-span-2 gap-6 flex flex-col">
                    <LoadItemText class="text-gray-800 text-lg font-semibold leading-7">
                        Shipment Loading
                    </LoadItemText>

                    <div class="flex flex-col gap-3">
                        <LoadItemText class="text-slate-600 text-sm font-medium leading-normal">
                            Load Selected Address
                        </LoadItemText>

                        <LoadContainer class="h-[240px]" />

                        <LoadItemText class="text-slate-600 text-sm font-medium leading-normal">
                            Loading Shipment & Delivery
                        </LoadItemText>

                        <div class="flex flex-row max-sm:flex-col gap-6">
                            <LoadContainer class="h-[140px]" />
                            <LoadContainer class="h-[140px]" />
                            <LoadContainer class="h-[140px]" />
                        </div>

                        <LoadItemText class="text-slate-600 text-sm font-medium leading-normal">
                            Loading Payment Method
                        </LoadItemText>

                        <div class="flex flex-row gap-6">
                            <LoadContainer class="h-[120px] max-w-[240px]" />
                            <LoadContainer class="h-[120px] max-w-[240px]" />
                        </div>

                        <LoadItemText class="text-slate-600 text-sm font-medium leading-normal">
                            Loading Shipping Notes
                        </LoadItemText>

                        <LoadContainer class="h-12" />
                    </div>
                </div>

                <LoadContainer class="h-[420px]" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import LoadContainer from './LoadContainer.vue';
import LoadItem from './LoadItem.vue';
import LoadItemText from './LoadItemText.vue';
</script>